import geotab from "./assets/images/companies/geotab.png";
import goldenrace from "./assets/images/companies/goldenrace.jpeg";
import hostgreen from "./assets/images/companies/hostgreen.jpg";
import intendia from "./assets/images/companies/intendia.png";
import roadto from "./assets/images/repo/road-to-independence.png";
import valhollrt from "./assets/images/repo/valhollrt-01.jpeg";
import vendesi from "./assets/images/repo/vende-sin-inmobiliaria.png";

import diego from "./assets/testimonial/diego.jpeg";
import puerta from "./assets/testimonial/puerta.jpeg";
import castilla from "./assets/testimonial/castilla.jpeg";

export const textContentMap = {
  titleSection: {
    mainTitle: "Full Stack Developer & Broadcast designer",
    subtitle:
      "I love programming, especially designing beautiful things. I'm passionate about what I do ;)",
  },
  skillsSection: {
    title: "Skills",
    subtitle: "A brief overview of my skills.",
  },
  projectsSection: {
    title: "Projects & Repositories",
    subtitle: "Talk is cheap. Show me the code,",
  },
  broadcastSection: {
    title: "Broadcast Reels",
    subtitle: "Demo reel about Broadcast Motion Graphics & scripting.",
  },
  coverLetterSection: {
    heading: "Cover letter",
    subheading: "Let me introduce myself",
    paragraphs: [
      `I am excited to apply for the <strong>Full Stack Software Developer</strong> position at your company. As a skilled developer with a diverse range of programming and IT skills, I am confident that I can contribute to your team's success. Currently, I work as a Full Stack Software Developer at <strong>Geotab</strong>, where I apply my knowledge in <strong>Java EE</strong> and <strong>.NET</strong> technologies for the development and maintenance of software solutions. Thanks to my experience in <strong>GWT</strong>, <strong>Typescript</strong>, <strong>Postgres</strong>, <strong>MariaDb</strong>, and <strong>Google Cloud</strong>, I can tackle complex cases, improve code, and troubleshoot to find innovative solutions, perform analysis, design architectures, and develop applications for <strong>Java/J2EE</strong> and <strong>Maven</strong>-based software systems. I also have experience in web development technologies and have worked with design patterns such as <strong>Front Controller</strong>, <strong>Data Access Object (DAO)</strong>, <strong>Data Transfer Object (DTO)</strong>, <strong>Session Facade</strong>, <strong>Service Locator</strong>, and <strong>Singleton</strong>.`,
    ],
    closing: ["Sincerely,", "<i>Aurelio Muñoz Hijano</i>"],
  },
  cvSection: {
    heading: "CV",
    subheading: "Download and share my CV",
  },
};

export const lastStepsPageTextContent = {
  heading: "A Bit More About Me ...",
  subheading:
    "Huge shoutout to all my pals who've helped me become a better pro. You know who you are! 🙌",
  presentDaySection: {
    heading: "Present Day 🙋‍♂️",
    paragraph1:
      "So, back in late 2019, I hopped on this awesome rollercoaster 🎢 as a <strong>Full Stack Developer</strong> at <strong>Intendia</strong>, which is part of the Geotab fam. My gig? Leveling up web apps in <strong>Fleet Management, Logistics, and Tachograph File Management</strong>. Massive shoutout 🙌 to my squad like Pedro Garcia, Alejandro Castilla, José Portillo, and especially the wise <strong>Ignacio Baca</strong>. These peeps have been real MVPs, teaching me the ropes and making the daily grind something special. 🛠️",
    paragraph2:
      "Fast forward to now, I'm still on the grind at Geotab, but with some extra flair. 💎 As a <strong>Full Stack Software Developer</strong>, my daily jam includes turning dreamy storyboards into real-deal apps, making sure the code is as clean as a whistle, and being a TDD wizard 🧙‍♂️. Tools of the trade? Think <strong>.Net, Postgres, Docker, GitLab,</strong> and the almighty <strong>Google Cloud</strong>. Let's not forget the Jedi-level OOP architectures (DI, MVP) and Functional Programming skills. 👾",
    paragraph3:
      "A big virtual hug 🤗 to <strong>Marcelo Carrillo, Sergio Ocaña, Diego Hauptman, Alejandro Puerta, Caffarena Brothers, Carlos Pimentel and the whole gang</strong> for vibing with me on this journey. The teamwork and unity are off the charts 📈, making our projects not just successful but also a blast to work on. Big love and thanks to everyone for making this ride unforgettable! 🌟",
  },
  spinOffSection: {
    heading: "Spin Off 🌀",
    paragraph1:
      "So, April 2018 was kinda epic! 🚀 I teamed up with Miss Motion and dove into the world of broadcast systems using <strong>Vizrt</strong> tech. We were all over the 2018 general elections on the national TV stage, aka <strong>TVE</strong>. Our mission? Delivering the eye candy 🍭 — I mean <strong>3D graphics and augmented reality</strong>.",
    paragraph2:
      "But hey, what made this gig truly rad wasn't just the tech wizardry. It was all about the good vibes with my laSexta peeps like <strong>José Sancho, Laura Garzón, and David Garcia</strong>. 🎥🌟",
  },
  greatAdventuresSection: {
    heading: "Great Adventures 🌍",
    paragraph1:
      "Way before the Miss Motion gig, back in 2018, I kicked off a wild ride 🎢 at <strong>Golden Race Sport Betting Virtual Solutions</strong>. I wore a bunch of hats 🎩— UI Designer, Animator, and even got my hands dirty with coding. Tools of the trade? <strong>Sketch, Invision, Google Web Designer</strong>, and I brought those animations to life with some <strong>Javascript and Angular</strong> magic.",
    paragraph2:
      "Shoutout to my squad—Santiago Manzi, Juan Rodríguez, and Miguel Guillem—but a special high-five 🙌 goes to <strong>Manuel Sagall</strong>, my go-to buddy who’s always had my back. And let's not forget <strong>Miguel Guillem</strong>, a UX guru who's taught me more than a thing or two. 🌟",
  },
  switchingGearsSection: {
    heading: "Switchin' Gears 🔄",
    paragraph1:
      "2017 was a game-changer! 🎮 Finished my CFGS in software app development with <strong>Ilerna</strong>, and jumped right into a 5-month internship at <strong>Hostgreen SL</strong>. I was all about iOS apps using Objective-C, and dabbled in PHP and MySQL for websites.",
    paragraph2:
      "Big thanks to <strong>Francisco Castilla</strong> for the shot, and a high-five 🙌 to my work buddy <strong>Ángel Jiménez</strong>. Oh, and I've been geeking out with <strong>Angular, Ionic, Firebase, and MongoDB</strong> on the side. Ever heard of KUp or <strong>Valholl RT</strong>? That's all me, baby!",
  },
  tvLandSection: {
    heading: "TV Land 📺",
    paragraph1:
      "Ah, the <strong>laSexta</strong> days... From <strong>2010 to 2018</strong>, I was in the trenches, whipping up <strong>graphic lines</strong> for shows and automating like a boss. 🤖",
    paragraph2:
      "Got my hands on <strong>MySQL, Vbs scripting, C++ plugins</strong>, mostly around the <strong>Vizrt</strong> platform. Even snagged myself a <strong>Professional Certificate in Vizrt Artist and Vizrt Trio</strong>. 🎓",
    paragraph3:
      "Super grateful to <strong>Angel Rodriguez Campoy</strong>, the dude who got me in the door. 🚪 I've also had the pleasure of sharing the stage with amazing peeps like <strong>José Sancho, Laura Garzón, Alejandro Montals, Carlos Lugo</strong>, and the list goes on. But hey, there's more to see, so check out my profile for the full scoop! 🕵️‍♂️",
  },
};

export const aboutUs = {
  paragraph: `<div>
    <p>Hey there, welcome to <strong>Sparanzza</strong>! 👋 Right now, I'm rockin' it as a <strong>Full Stack Developer</strong>. But don't get it twisted, I've also been deep in <strong>design</strong> and <strong>broadcast graphics</strong> for years. This site isn't just a digital resume—it's the scrapbook of my professional life.</p>
    <p>So dive in, explore, and let's connect! This website is my 'thank you' to everyone who's made this ride unforgettable. Let's keep building!</p>
  </div>`,

  paragraph2: `<div>
  <h4>From television to programming, a journey fueled by passion! </h4>
  <p>After more than 18 years designing for major networks like La Sexta and TVE in Madrid, I always kept my passion for technology alive. From personal projects to late-night coding sessions, programming has always been my adventure companion. 💻🌙</p>
  <p>Today, in Malaga, I combine my life as a Java and .NET C# developer with the greatest joy of my life: being a father. My family is my driving force, inspiring me to continue learning and growing in this exciting world of programming.</p>
  <p>And I can't forget my friends, many of whom I consider brothers  ❤️. Honestly, I couldn't have made it this far without their support and companionship. They've made this journey not only successful but also a wonderful life!🙏 Thank you.</p>
</div>`,
};

export const experiences = [
  {
    company: "Geotab",
    logo: geotab,
    position: "Full Stack .Net / React Developer",
    date: "May 2023 - Present",
    description:
      "As a Full Stack Developer at Geotab, I contribute to the MyGeotab platform, focusing on C# .NET backend development and creating intuitive React interfaces with TypeScript. I've gained expertise in fleet management technologies, migrated legacy Java services to C# .NET, developed React views for data visualization, and integrated an external system, improving functionality and efficiency. I've also implemented CI/CD solutions using GitLab, Docker, and XUnit, and gained experience with Google Cloud Platform ...",
  },
  {
    company: "Intendia",
    logo: intendia,
    position: "Full Stack Java / GWT Developer",
    date: "Sep 2019 - May 2023",
    description:
      "At Intendia, I spent 4 years developing a fleet logistics web platform as a Full Stack Developer. I worked with Java EE, Servlet, JDBC, GWT, Hibernate, and other technologies, gaining experience in backend, frontend, and methodologies like TDD and reactive programming. I participated in migrating the business logic to .NET, which allowed me to acquire skills in C#, TypeScript, and React, preparing me for my next role as a developer in these technologies ...",
  },
  {
    company: "GoldenRace",
    logo: goldenrace,
    position: "UI/UX Motion Designer",
    date: "Jan 2016 - Dec 2017",
    description:
      "Design, animate and maintain the front-end graphics system for all virtual betting events on the platform using Sketch and InVision. Always looking for and developing new technologies.",
  },
  {
    company: "HostGreen",
    logo: hostgreen,
    position: "Developer iOS / Android",
    date: "Jan 2016 - Dec 2017",
    description:
      "During my internship, I worked as an iOS and Android app developer, where I gained experience developing mobile applications as solutions for e-commerce and SEO.",
  },
];


export const projectsDetails = [
  {
    number: "01",
    title: "Valholl Real time",
    summary: `Personal project to create a free online platform for broadcast graphics design and digital content creation. The platform incorporates cutting-edge tools and methodologies to offer a robust graphics system. Besides aiming to be a strong competitor in the broadcast industry, ValhollRT is a tribute to the graphic designers who have collaborated on the project.`,
    imageUrl: valhollrt, // Reemplaza con la ruta real de tu imagen
    link: "https://github.com/ValhollRT/Odin-DEPRECATED-",
  },
  {
    number: "02",
    title: "Road To Independence",
    summary: `
    "Camino a la Independencia" is a short game that offers a unique perspective on Catalonia's independence movement. You control Carles Puigdemont, navigating through a vertical rail scenario to collect as many votes as possible for a unilateral declaration of independence. The catch? You must act fast before Mariano Rajoy appears to invoke Article 155 and halt everything.`,
    imageUrl: roadto,
    link: "https://github.com/Sparanzza/DeathLineGame",
  },
  {
    number: "03",
    title: "Vende Sin Inmobiliaria",
    summary: `"VendeSin Inmobiliaria" is an Android app designed to make real estate transactions easier and more practical without the need for a real estate agent. The app aims to be current and useful for a broad audience, touching on themes closely related to the development team's own experiences in the real estate world.`,
    imageUrl: vendesi,
    link: "https://github.com/Sparanzza/VendeSinInmobiliaria",
  },
];

export const testimonials = [
  {
    name: "Alejandro Castilla Quesada",
    avatar:castilla,
    position: "Senior Software Developer at Geotab",
    text: "His professional background has always been interesting to me, as he has worked in some environments where he had a high pressure and the time was gold. Also, he became a key member in a company where, shamefully, they weren’t capable to appreciate how good he and his team (...)",
  },
  {
    name: "Diego Haptman",
    avatar:diego,
    position: "Software Developer at Geotab",
    text: " I highly recommend Aurelio Munoz for any software development position. He is a highly skilled and experienced engineer with exceptional problem-solving abilities, a deep understanding of software development principles and techniques, and excellent communication and leadership skills (...).",
  },
  {
    name: "Alejandro Puerta Medina",
    avatar:puerta,
    position: "Senior Software Developer at Geotab",
    text: "As a developer, Aurelio has a deep understanding of Java and .NET technologies, and they have used their expertise to create and maintain software solutions that meet the needs of the project. Their proficiency in GWT, Typescript, Postgres, MariaDb, and Google Cloud has enabled them to tackle complex projects (...) ",
  },
];